import { RefactoredDevice } from '../../../@types/model/device';
import BarDeliver from './pieces/BarDeliver';
import { useTranslation } from 'react-i18next';
import { DeliverFilter } from '../../../@types/model/deliver';
import '../../../assets/css/newDeliver.scss';

type DeliveryBarProps = {
  rd: RefactoredDevice;
  unit: string;
  tableFilter: DeliverFilter;
  percentSlots: number;
  percentInitial: number;
  extraPercentage: number;
  amountSlots: number;
};

const DeliveryBar = (props: DeliveryBarProps) => {
  const { t } = useTranslation();

  return (
    <BarDeliver className="barDeliver">
      <div
        className="barDeliverData"
        style={{
          backgroundColor: props.rd.backgroundPercent,
          color: props.rd.colorPercent,
          width: props.percentInitial + '%'
        }}
      >
        {Math.round(props.rd.percent)}%
      </div>
      {props.amountSlots > 0 && (
        <div
          className="slotFill"
          style={{
            width: props.percentSlots + '%'
          }}
        >
          {props.amountSlots + props.unit}
        </div>
      )}
      <div
        className="barFull"
        style={{
          left: 100 / (1 + props.extraPercentage / 100) + '%',
          width: props.extraPercentage + '%'
        }}
      >
        100%
      </div>
      <span
        style={{
          position: 'absolute',
          bottom: '-15px',
          right: '0px',
          fontSize: '10px'
        }}
      >
        {t('capacity')} {props.rd.capacidad}
      </span>
    </BarDeliver>
  );
};
export default DeliveryBar;
